import { render, staticRenderFns } from "./SystemStatistics.vue?vue&type=template&id=b1a46e74&scoped=true"
import script from "./SystemStatistics.vue?vue&type=script&lang=js"
export * from "./SystemStatistics.vue?vue&type=script&lang=js"
import style0 from "./SystemStatistics.vue?vue&type=style&index=0&id=b1a46e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a46e74",
  null
  
)

export default component.exports